import _countBy from 'lodash/countBy';
import _groupBy from 'lodash/groupBy';
import _pick from 'lodash/pick';
import { AddonGroupedCartItem, GroupedPriceByVariant } from '@niaratech/ota-components/src/components/AddonCart/AddonCartItem/AddonCartItem';
import { ShoppingCartState } from '../../app/reducers/shoppingCart';
const groupAddonCartItems = (addonCartItems: Array<ShoppingCartState['addonCartItems'][number] & {
  onRemove?: () => void;
}>): AddonGroupedCartItem[] => {
  const groupedAddonsByIdAndSchedule = _groupBy(addonCartItems, addonCartItem => JSON.stringify(_pick(addonCartItem, 'addonResult[addonId]', 'scheduleDate', 'scheduleTime')));

  // Função para determinar a ordem de exibição do addon
  const getPriority = (item: AddonGroupedCartItem): number => {
    const addon = item?.addon;
    if (addon?.mandatoryPurchase === true && addon?.shouldIncludeAddonInRate === true) {
      return 1; // Primeira prioridade
    }
    if (addon?.mandatoryPurchase === true) {
      return 2; // Segunda prioridade
    }
    return 3; // Terceira prioridade (resto)
  };

  // Extras Agrupados para os mostrar no carrinho
  const groupedCartItems: AddonGroupedCartItem[] = Object.values(groupedAddonsByIdAndSchedule).map(addonGroup => {
    const baseAddon = addonGroup?.[0]?.addonResult?.addon;
    const variantIdCount = _countBy(addonGroup, addonItem => addonItem?.variantId);
    const variants = Object.keys(variantIdCount).map(variantId => {
      const variant = baseAddon?.priceByVariant?.find(variant => variant?.id === variantId);
      const showAges = variant?.fromAge !== null && variant?.fromAge >= 0 && variant?.toAge !== null && variant?.toAge >= 0;
      return {
        ...variant,
        quantity: variantIdCount[variantId],
        showAges
      } as GroupedPriceByVariant;
    });
    const priceCompositions = addonGroup.map(item => item?.addonResult?.priceComposition);
    const totalPrice = priceCompositions?.reduce((acc, priceComposition) => {
      return {
        total: {
          ...acc?.total,
          value: acc?.total?.value + priceComposition?.total?.value
        }
      };
    });
    return {
      addon: baseAddon,
      scheduleDate: addonGroup?.[0]?.scheduleDate,
      scheduleTime: addonGroup?.[0]?.scheduleTime,
      onRemoveGroupedItems: () => {
        addonGroup.forEach(addon => addon?.onRemove?.());
      },
      variants,
      totalPrice
    };
  });
  return groupedCartItems?.sort((a, b) => getPriority(a) - getPriority(b));
};
export default groupAddonCartItems;